import { ErrorLayout } from 'features/verify/ui/error-layout';
import { verificationCancel } from 'model/flows/verification.model';
import { sendEvent } from 'model/helpers/events.model';
import { screenHistoryPush, ScreenName } from 'model/helpers/screens-history';
import { useLocalization } from 'model/localization.model';
import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';

import { Button } from 'ui/atoms/button';

export const InvalidSession = () => {
	const t = useLocalization();
	const [start] = useState(Date.now());

	useEffect(() => {
		screenHistoryPush(ScreenName.invalid_session_mobile);
		setTimeout(() => {
			sendEvent({
				event: 'invalid_session_screen_shown',
				event_attributes: {
					type: 'mobile',
				},
			});
		}, 20)
	}, []);
	const handleRestart = () => {
		sendEvent({
			event: 'invalid_session_restart',
			event_attributes: {
				type: 'mobile',
				duration: Date.now() - start,
			},
		});
		verificationCancel();
	};

	return (
		<ErrorLayout
			title={t('session.err.title')}
			description={t('session.err.subtitle')}
		>
			<Button
				name={'session.err.btn'}
				onClick={handleRestart}
			>
				{t('session.err.btn')}
			</Button>
		</ErrorLayout>
	);
};
